import clsx from "clsx"
import React from "react"
import { DropdownButton, Dropdown } from "react-bootstrap"
import SVG from "react-inlinesvg"

const KebabIcon = () => (
  <svg width="17" height="18" viewBox="0 0 515.555 515.555" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0" />
    <path d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0" />
    <path d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0" />
  </svg>
)

const CustomToggle = React.forwardRef(({ onClick, variant }, ref) => (
  <button
    ref={ref}
    onClick={e => { e.preventDefault(); onClick(e) }}
    className={`btn btn-${variant || "outline-primary"}`}
    style={{ padding: "8px", borderRadius: "8px", lineHeight: 1 }}>
    <KebabIcon />
  </button>
))
CustomToggle.displayName = "CustomToggle"

const renderItems = (dropdownList) =>
  dropdownList.map((item, index) => {
    if (!item.showed) return null
    return (
      <React.Fragment key={index}>
        <Dropdown.Item
          eventKey={index}
          onClick={item.action}
          disabled={item.disabled}
          className={clsx("d-flex align-items-center", item.disabled ? "cursor-not-allowed" : "cursor-pointer")}>
          <SVG className="mr-2 mb-1" src={item.icon} />
          <div className={"text"} style={{ color: item.disabled ? "#D1D1D1" : undefined }}>{item.title}</div>
        </Dropdown.Item>
      </React.Fragment>
    )
  })

export const ButtonDropdown = ({ title, dropdownList, variant, iconOnly }) => {
  const resolvedVariant = variant || "outline-primary"

  if (iconOnly) {
    return (
      <Dropdown alignRight>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-icon-toggle" variant={resolvedVariant} />
        <Dropdown.Menu>
          {renderItems(dropdownList)}
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  return (
    <DropdownButton
      variant={resolvedVariant}
      alignRight
      title={title}
      id="dropdown-menu-align-right">
      {renderItems(dropdownList)}
    </DropdownButton>
  )
}
